import { createActions } from 'redux-actions'

export const { modals } = createActions({
  MODALS: {
    SET_MODAL_LIST_PROJECTS: (status) => ({ status }),
    SET_MODAL_WELCOME: (status) => ({ status })
  }
})
